import { render, staticRenderFns } from "./DefaultConfig.vue?vue&type=template&id=4985f21a&scoped=true"
import script from "./DefaultConfig.vue?vue&type=script&lang=js"
export * from "./DefaultConfig.vue?vue&type=script&lang=js"
import style0 from "./DefaultConfig.vue?vue&type=style&index=0&id=4985f21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985f21a",
  null
  
)

export default component.exports